import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { groupBy } from "../../../helpers/groupBy";
import moment from "moment";
//components
import Container from "../../../components/container/container";
import NavBarUser from "../../../components/navigation/NavBarUser";
//icons
// import AlarmDefault from "../../../assets/images/icons/alarm-clock.svg";
// import AlarmRed from "../../../assets/images/icons/alarm-clock-red.svg";
// import MapDefault from "../../../assets/images/icons/map.svg";
import Location from "../../../assets/images/icons/Location.svg";
import EmptyCart from "../../../assets/images/emptyState/cart.svg";
// import ShipperDefault from "../../../assets/images/icons/shipper-bare.svg";
// import ShipperRed from "../../../assets/images/icons/shipper-bare-red.svg";
import Coupon from "../../../assets/images/icons/coupon.svg";
import Delivery from "../../../assets/images/icons/Delivery.svg";
import ChevronRight from "../../../assets/images/icons/chevron-right.svg";
import Instructions from "../../../assets/images/icons/instructions.svg";
import Timer from "../../../assets/images/icons/timer.svg";
import Checkout from "./components/Checkout";
import { cleanInput } from "../../../helpers/cleanInput";
import RestaurantItems from "./productType/Restaurant";
import PackageItems from "./productType/Package";
import StoreItems from "./productType/Store";
import { AddressModal } from "../../../components/modals/address/addressModal";
import { AddCouponModal } from "../../../components/modals/addCouponModal";
import { AddDeliveryInstructionModal } from "../../../components/modals/AddDeliveryInstructionModal";
import {
  showMyCart,
  showMyCartNoProperties,
  editCart,
  emptyCart,
  storePublicCartProducts,
} from "../../../redux/cart/cartAction";
import { getMyAddressesAction } from "../../../redux/address/addressActions";
import { isAuthenticatedUser, getUserFromStorage } from "../../../utils/Auth";
import {
  filterPublicShippers,
  getAllPublicShippers,
  storeCurrentShipper,
} from "../../../redux/publicShippers/publicShippersActions";
import { showApplication } from "../../../redux/applicationSettings/applicationAction";
import { SelectShipperModal } from "../../../components/modals/selectShipperModal";

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function Cart() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuth = isAuthenticatedUser();
  const user = getUserFromStorage();
  const localCart = JSON.parse(localStorage.getItem("ogwugo-cart"));

  const [myCart, setMyCart] = useState([]);
  const [isOpenAddressModal, setIsOpenAddressModal] = useState(false);
  const [isOpenShipperModal, setIsOpenShipperModal] = useState(false);
  const [isOpenCouponModal, setIsOpenCouponModal] = useState(false);
  const [isOpenDeliveryModal, setIsOpenDeliveryModal] = useState(false);
  const [currentShipper, setCurrentShipper] = useState({});

  const { myAddresses } = useSelector((state) => state.address);
  const { allPublicShippers, setShipper } = useSelector(
    (state) => state.publicShippers
  );
  const { myCarts, myCartNoProperties, cartProducts } =
    useSelector((state) => state.cart);

  const group_restaurant = groupBy(myCart?.products, "restaurant_id");
  const group_store = groupBy(myCart?.products, "store_id");

  let currentAddress = myAddresses?.data?.filter(function (address) {
    return address.address_selected === true;
  });


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isAuth) {
      dispatch(getMyAddressesAction());
      dispatch(showMyCartNoProperties());
      dispatch(getAllPublicShippers());
    }
    dispatch(showApplication());
    // eslint-disable-next-line
  }, []);

  // Fetch addresses whenever the modal closes
  useEffect(() => {
    if (isAuth && !isOpenAddressModal) {
      dispatch(getMyAddressesAction());
    }
    // eslint-disable-next-line
  }, [isOpenAddressModal]);

  useEffect(() => {
    if (isAuth && currentShipper?.id) {
      const payload = { shipper_id: currentShipper?.id };
      
      // Add delivery_mode_id if it exists
      if (currentShipper?.delivery_mode_id) {
        payload.delivery_mode_id = currentShipper?.delivery_mode_id;
      }

      if (currentAddress?.length > 0) {
        payload.address_id = currentAddress?.[0]?.id;
      }

      dispatch(showMyCart(payload));
    }
    // eslint-disable-next-line
  }, [currentShipper?.id, currentAddress?.[0]?.id, currentShipper?.delivery_mode_id]);

  // Refresh cart when shipper modal closes (only if user clicked close without selecting)
  // The shipper change effect above handles when a new shipper is selected
  // This handles edge case where modal closes without shipper changing

  // Get public shippers even if the user has no address
  useEffect(() => {
    dispatch(
      filterPublicShippers(
        {
          date: moment(new Date()).format("YYYY-MM-DD HH:mm"),
          pagination: 0,
        },
        1
      )
    );
    // eslint-disable-next-line
  }, []);

  // set current shipper based on public shippers data
  useEffect(() => {
    let singleCurrentShipper = allPublicShippers?.data?.find(
      (s) => s.shipper_selected === true
    );

    if (setShipper?.id) {
      // User has manually selected a shipper, use it
      setCurrentShipper(setShipper);
    } else if (singleCurrentShipper) {
      // No manual selection, use the default from API
      setCurrentShipper(singleCurrentShipper);
      dispatch(storeCurrentShipper(singleCurrentShipper));
    }
    // eslint-disable-next-line
  }, [allPublicShippers, setShipper]);

  useEffect(() => {
    if (isAuth) {
      myCarts && setMyCart(myCarts);
      return;
    } else {
      // const cartItems = JSON.parse(localStorage.getItem("ogwugo-cart-items"));
      // console.log("cartItems", cartItems);
      if (cartProducts?.data) {
        setMyCart(cartProducts?.data);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myCarts, cartProducts]);

  function getTotalItemPrice(product, price) {
    let foodPrice = Number(price) * Number(product.quantity);
    let totalPrice = 0;
    for (let i = 0; i < product?.attributes?.length; i++) {
      totalPrice +=
        Number(product?.attributes[i]?.amount) *
        Number(product?.attributes[i]?.quantity);
    }
    return numberWithCommas(Number(totalPrice) + Number(foodPrice));
  }

  //remove cart product items
  const removeCartProductItem = async (delete_id) => {
    //if user is logged in, delete from online cart items
    //else delete from local cart items
    const newProducts = myCart.products.filter(
      (product) => product.delete_id !== delete_id
    );
    setMyCart({ ...myCart, products: newProducts });
    if (isAuth) {
      try {
        //if the total products remaining is greater than 0, update cart.
        //else if the last product was removed, empty the cart then update
        //the cart with whatever is remaining after deleting the item
        if (newProducts.length > 0) {
          let newObj = { ...myCart, products: newProducts };
          cleanInput(newObj);
          const response = await dispatch(
            editCart({
              user_id: user.id,
              ...newObj,
            })
          );
          if (response) {
            await dispatch(showMyCart());
            window.dispatchEvent(new Event("cartCleared"));
          }
        } else {
          let newObj = { ...myCart, products: newProducts };
          cleanInput(newObj);
          const emptyResponse = await dispatch(
            emptyCart({ user_id: user?.id })
          );
          if (emptyResponse.status === "success") {
            const response = await dispatch(
              editCart({
                user_id: user.id,
                ...newObj,
              })
            );
            if (response) {
              await dispatch(showMyCart());
              window.dispatchEvent(new Event("cartCleared"));
            }
          }
        }
      } catch (error) {
        console.log("error", error);
      }
    } else {
      //updating cart involves getting what is left from deleting,
      //updating the public cart products onlune and updating the localhost
      let updateCart = localCart;
      updateCart.products = newProducts;
      if (newProducts.length > 0) {
        try {
          const response = await dispatch(storePublicCartProducts(updateCart));
          if (response) {
            localStorage.setItem(
              "ogwugo-cart-items",
              JSON.stringify(response?.data)
            );
            localStorage.setItem("ogwugo-cart", JSON.stringify(updateCart));
            window.dispatchEvent(new Event("localStorageUpdated"));
            setMyCart(response?.data);
          }
        } catch (error) {
          console.log("error", error);
        }
      } else {
        try {
          const response = await dispatch(
            storePublicCartProducts({ ...updateCart, products: null })
          );
          if (response) {
            localStorage.setItem(
              "ogwugo-cart-items",
              JSON.stringify(response?.data)
            );
            localStorage.setItem("ogwugo-cart", JSON.stringify(updateCart));
            window.dispatchEvent(new Event("localStorageUpdated"));
            setMyCart(response?.data);
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    }
  };

  //remove cart package items
  const removeCartPackageItem = async (delete_id) => {
    //if user is logged in, delete from online cart items
    //else delete from local cart items
    const toViewCart = myCart.packages.filter(
      (pack) => pack.delete_id !== delete_id
    );
    setMyCart({ ...myCart, packages: toViewCart });

    if (isAuth) {
      const newPackages = myCartNoProperties.packages.filter(
        (pack) => pack.delete_id !== delete_id
      );
      try {
        if (newPackages.length > 1) {
          let newObj = { ...myCart, packages: newPackages };
          cleanInput(newObj);
          const response = await dispatch(
            editCart({
              user_id: user.id,
              ...newObj,
            })
          );
          if (response) {
            await dispatch(showMyCart());
            window.dispatchEvent(new Event("cartCleared"));
          }
        } else {
          let newObj = { ...myCart, packages: newPackages };
          cleanInput(newObj);
          const emptyResponse = await dispatch(emptyCart({ user_id: user.id }));
          if (emptyResponse.status === "success") {
            const response = await dispatch(
              editCart({
                user_id: user.id,
                packages: null,
                ...newObj,
              })
            );
            if (response) {
              await dispatch(showMyCart());
              window.dispatchEvent(new Event("cartCleared"));
            }
          }
        }
      } catch (error) {
        console.log("error", error);
      }
    } else {
      //updating cart involves getting what is left from deleting,
      //updating the public cart products onlune and updating the localhost
      let updateCart = localCart;
      updateCart.packages = toViewCart;

      if (toViewCart?.length > 0) {
        // try {
        //   const response = await dispatch(storePublicCartProducts(updateCart));
        //   if (response) {
        //     localStorage.setItem(
        //       "ogwugo-cart-items",
        //       JSON.stringify(response?.data)
        //     );
        //     localStorage.setItem("ogwugo-cart", JSON.stringify(response?.data));
        //     setMyCart(response?.data);
        //   }
        // } catch (error) {
        //   console.log("error", error);
        // }
      } else {
        try {
          const response = await dispatch(
            storePublicCartProducts({ ...updateCart, packages: null })
          );
          if (response) {
            localStorage.setItem(
              "ogwugo-cart-items",
              JSON.stringify(response?.data)
            );
            localStorage.setItem("ogwugo-cart", JSON.stringify(response?.data));
            window.dispatchEvent(new Event("localStorageUpdated"));
            setMyCart(response?.data);
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    }
  };

  function getCartTotal() {
    //check if the user is logged in first if the user is login,
    //get the total from the sum of the online cart packages and products
    //else get the total from the local storage package and products
    if (isAuth && (myCart?.products || myCart?.packages)) {
      let product_no = myCart?.products ? Number(myCart?.products?.length) : 0;
      let package_no = myCart?.packages ? Number(myCart?.packages?.length) : 0;
      return product_no + package_no;
    } else {
      if (localCart?.products || localCart?.packages) {
        let product_local = localCart?.products
          ? Number(localCart?.products?.length)
          : 0;
        let package_local = localCart?.packages
          ? Number(localCart?.packages?.length)
          : 0;
        return product_local + package_local;
      } else {
        return 0;
      }
    }
  }

  const cartTotal = getCartTotal();

  const clearCart = async () => {
    console.log('clearCart called, isAuth:', isAuth);
    if (isAuth) {
      const emptyResponse = await dispatch(emptyCart({ user_id: user.id }));
      if (emptyResponse.status === "success") {
        await dispatch(showMyCart());
        console.log('Dispatching cartCleared event');
        window.dispatchEvent(new Event("cartCleared"));
      }
    } else {
      console.log('Guest user clearing cart');
      // Read fresh localCart from storage
      const currentLocalCart = JSON.parse(localStorage.getItem("ogwugo-cart")) || {};
      console.log('currentLocalCart:', currentLocalCart);
      let updateCart = { ...currentLocalCart };
      updateCart.products = null;
      updateCart.packages = null;
      console.log('updateCart:', updateCart);

      const response = await dispatch(storePublicCartProducts(updateCart));
      console.log('storePublicCartProducts response:', response);
      if (response) {
        localStorage.setItem(
          "ogwugo-cart-items",
          JSON.stringify(response?.data)
        );
        localStorage.setItem("ogwugo-cart", JSON.stringify(updateCart));
        console.log('Dispatching localStorageUpdated event');
        window.dispatchEvent(new Event("localStorageUpdated"));
        setMyCart(response?.data);
      } else {
        console.log('No response from storePublicCartProducts');
      }
    }
  };

  return (
    <div data-test="cartComponent">
      <NavBarUser />
      <div className="shadow-md mb-6 sm:mb-16">
        <Container>
          <div className="py-4 sm:pt-12 sm:pb-6">
            <h2
              className="text-[#333333] dark:text-white text-3xl sm:text-5xl font-bold mb-0 sm:mb-4"
              style={{ lineHeight: "64px" }}
            >
              My Cart
            </h2>
            <p className="text-lg text-gray-400 dark:text-[#BCBCBC] -mt-1 sm:mt-0">
              {cartTotal} Item
              {cartTotal > 1 ? "s" : ""} in the cart
            </p>
          </div>
        </Container>
      </div>

      <Container>
        <main className="pb-8">
          <div className="max-w-3xl mx-auto lg:max-w-7xl">
            {/* Main 3 column grid */}
            <div className="grid grid-cols-1 gap-4 items-start lg:grid-cols-3 lg:gap-16">
              {/* Left column */}
              <div className="grid grid-cols-1 gap-4 lg:col-span-2">
                <section aria-labelledby="section-1-title">
                  <h2 className="sr-only" id="section-1-title">
                    Section title
                  </h2>
                  {/* Your content */}

                  <div>
                    {/* Delivery details i.e: user address */}
                    <div className="sm:max-w-3xl mb-4">
                      <h3 className="text-2xl font-medium mb-2">
                        1. Delivery Details
                      </h3>
                      <p className="dark:text-[#BCBCBC]">
                        Make sure your delivery details are correct.
                      </p>
                    </div>

                    <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden px-4 py-5 mb-12 shadow-[0px_18px_40px_0px_#7090B01F]">
                      {/* Current address/change */}
                      <div className="flex justify-between my-1 py-2 border-b border-[#EEEEEE]">
                        <div className="flex gap-2">
                          {/* <img
                            src={MapDefault}
                            alt="icon"
                            className="mr-2 w-[32px] h-auto hidden dark:block"
                          /> */}
                          <img
                            src={Location}
                            alt="icon"
                            className="mr-2 w-[32px] h-auto"
                          />

                          <div>
                            <p className="text-[#344B67] dark:text-white">Deliver To</p>
                            {isAuth ? (
                              currentAddress?.length > 0 ? (
                                currentAddress?.map((address, i) => (
                                  <p key={i}>
                                    {address?.address}, {address?.city},{" "}
                                    {address?.country},{" "}
                                  </p>
                                ))
                              ) : (
                                <p>You have not set a current delivery address</p>
                              )
                            ) : (
                              <p className="text-gray-500 text-sm">
                                You need to login to set a delivery address
                              </p>
                            )}
                          </div>
                        </div>

                        {isAuth ? (
                          <button
                            type="button"
                            className="flex items-center gap-1"
                            onClick={() => setIsOpenAddressModal(true)}
                          >
                            <span className="text-primary-500 text-sm">Change</span>
                            <img
                              src={ChevronRight}
                              alt="icon"
                              className="w-[16px] h-auto"
                            />
                          </button>
                        ) : (
                          ""
                        )}
                      </div>

                      {/* current shipper/change */}
                      <div className="flex justify-between my-1 py-2 border-b border-[#EEEEEE]">
                        <div className="flex gap-2">
                          {/* <img
                            src={ShipperDefault}
                            alt="icon"
                            className="mr-2 w-[32px] h-auto hidden dark:block"
                          /> */}
                          <img
                            src={Delivery}
                            alt="icon"
                            className="mr-2 w-[32px] h-auto"
                          />

                          <div>
                            <p className="text-[#344B67] dark:text-white">Delivery Partner</p>
                            {currentShipper && currentShipper?.name ? (
                              <div>
                                <p className="text-sm capitalize">{currentShipper?.name}</p>
                                {currentShipper?.delivery_mode && (
                                  <p className="text-xs text-gray-500 dark:text-gray-400 capitalize">
                                    {currentShipper?.delivery_mode?.title} 
                                    {currentShipper?.delivery_mode?.pivot?.charge > 0 && (
                                      <span className="ml-1">
                                        (+ ₦{numberWithCommas(currentShipper?.delivery_mode?.pivot?.charge)})
                                      </span>
                                    )}
                                  </p>
                                )}
                              </div>
                            ) : (
                              <p className="text-sm">You have not set any shipper</p>
                            )}
                          </div>
                        </div>

                        <button
                          type="button"
                          className="flex items-center gap-1"
                          onClick={() => setIsOpenShipperModal(true)}
                        >
                          <span className="text-primary-500 text-sm">Change</span>
                          <img
                            src={ChevronRight}
                            alt="icon"
                            className="w-[16px] h-auto"
                          />
                        </button>
                      </div>

                      {/* estimated delivery */}
                      <div className="flex mb-4 justify-between items-center py-2">
                        <div className="flex gap-2">
                          {/* <img
                            src={AlarmDefault}
                            alt="icon"
                            className="mr-2 w-[32px] h-auto hidden dark:block"
                          /> */}
                          <img
                            src={Timer}
                            alt="icon"
                            className="mr-2 w-[32px] h-auto"
                          />
                          <div>
                            <p className="text-[#344B67] dark:text-white">Estimated Delivery</p>
                            <p className="text-sm">30-40 mins</p>
                          </div>
                        </div>
                        <div className="h-fit bg-[#D1FED8] px-3 py-1 rounded-lg">
                          <span className="text-[#115E1D] text-sm font-medium">On Time</span>
                        </div>
                      </div>
                    </div>

                    <section className="mb-12">
                      <div className="mb-4">
                        <h3 className="text-2xl font-medium mb-2">
                          2. Order Summary
                        </h3>
                        <p className="dark:text-[#BCBCBC]">
                          Review your selected items here:
                        </p>
                      </div>

                      {/* Empty Cart */}
                      {(!myCart?.products || myCart?.products?.length === 0) &&
                        (!myCart?.packages || myCart?.packages?.length === 0) && (
                          <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden px-4 py-5 mb-6 shadow-[0px_18px_40px_0px_#7090B01F]">

                            <img
                              src={EmptyCart}
                              alt="Empty"
                              className="mt-8 h-[160px] w-auto mx-auto"
                            />

                            <div className="text-center my-6">
                              <p className="text-xl font-bold py-2">
                                Your cart is empty
                              </p>
                              <p className="text-[#676565]">
                                Tap “Discover More Products” to continue
                              </p>
                            </div>

                            <div className="border-t border-[#DADADA] mt-8">
                              <div className="justify-between flex w-full">
                                <button
                                  className="text-lg text-primary-500 font-medium py-3 cursor-pointer"
                                  onClick={() => navigate("/user/home")}
                                >
                                  + Discover More Products
                                </button>

                                <button
                                  type="button"
                                  disabled
                                  className="text-lg text-[#676565] font-medium py-3"
                                >
                                  Clear Cart
                                </button>
                              </div>
                            </div>
                          </div>
                        )}

                      {/*Cart Product list based on outlet i.e restaurant, store etc. */}
                      {myCart?.products?.length > 0 &&
                        Object.keys(group_restaurant).map(
                          (group, i) =>
                            group !== "undefined" && (
                              <RestaurantItems
                                key={i}
                                group={group}
                                group_restaurant={group_restaurant}
                                getTotalItemPrice={getTotalItemPrice}
                                removeCartItem={removeCartProductItem}
                                setMyCart={setMyCart}
                              />
                            )
                        )}

                      {myCart?.products?.length > 0 &&
                        Object.keys(group_store).map(
                          (group, i) =>
                            group !== "undefined" && (
                              <StoreItems
                                key={i}
                                group={group}
                                group_store={group_store}
                                getTotalItemPrice={getTotalItemPrice}
                                removeCartItem={removeCartProductItem}
                                setMyCart={setMyCart}
                              />
                            )
                        )}

                      {myCart?.packages?.length > 0 && (
                        <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden border px-4 py-5 shadow-lg">
                          <div>
                            <h3 className="text-xl font-medium mb-6 pb-3 border-b">
                              Package Summary
                            </h3>
                            {myCart?.packages?.length > 0 &&
                              myCart?.packages.map((pack, i) => (
                                <PackageItems
                                  key={i}
                                  pack={pack}
                                  removeCartItem={removeCartPackageItem}
                                />
                              ))}
                            <div className="border-t border-[#DADADA] mt-8">
                              <div className="justify-between flex w-full">
                                <button
                                  className="text-lg text-primary-500 font-medium py-3 cursor-pointer"
                                  onClick={() => navigate("/user/food-packages")}
                                >
                                  + Add another package
                                </button>

                                <button
                                  type="button"
                                  className="text-lg text-primary-500 font-medium py-3 cursor-pointer"
                                  onClick={() => clearCart()}
                                >
                                  Clear Cart
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </section>

                    <section className="mb-12">
                      <div className="mb-4">
                        <h3 className="text-2xl font-medium mb-2">
                          3. Additional Options (Optional)
                        </h3>
                        <p className="dark:text-[#BCBCBC]">
                          Add a coupon or delivery instruction
                        </p>
                      </div>

                      <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden px-4 py-5 mb-12 shadow-[0px_18px_40px_0px_#7090B01F]">
                        {/* Coupon Code */}
                        <div className="flex justify-between my-1 py-2 border-b border-[#EEEEEE]">
                          <div className="flex gap-2">
                            <img
                              src={Coupon}
                              alt="icon"
                              className="mr-2 w-[32px] h-auto dark:hidden"
                            />

                            <div>
                              <p className="text-[#344B67] dark:text-white">Coupon Code</p>
                              <p className="text-gray-500 text-sm">
                                {myCart?.coupons?.[0]?.coupon_slug ||
                                  myCart?.promotion_codes?.[0]?.promotion_code_slug ||
                                  "No coupon applied"}
                              </p>
                            </div>
                          </div>

                          <button
                            type="button"
                            className="flex items-center gap-1"
                            onClick={() => setIsOpenCouponModal(true)}
                          >
                            <span className="text-primary-500 text-sm">{myCart?.coupons?.[0]?.coupon_slug ||
                              myCart?.promotion_codes?.[0]?.promotion_code_slug ? "Edit" : "Add Code"}</span>
                            <img
                              src={ChevronRight}
                              alt="icon"
                              className="w-[16px] h-auto"
                            />
                          </button>
                        </div>

                        {/* Delivery Instructions */}
                        {isAuth && <div className="flex justify-between my-1 py-2">
                          <div className="flex gap-2">
                            <img
                              src={Instructions}
                              alt="icon"
                              className="mr-2 w-[32px] h-auto dark:hidden"
                            />

                            <div>
                              <p className="text-[#344B67] dark:text-white">Delivery Instructions</p>
                              <p className="text-gray-500 text-sm">
                                {currentAddress?.[0]?.description || "No instructions added"}
                              </p>
                            </div>
                          </div>

                          <button
                            type="button"
                            className="flex items-center gap-1"
                            onClick={() => setIsOpenDeliveryModal(true)}
                          >
                            <span className="text-primary-500 text-sm">
                              {currentAddress?.[0]?.description ? "Edit" : "Add Note"}
                            </span>
                            <img
                              src={ChevronRight}
                              alt="icon"
                              className="w-[16px] h-auto"
                            />
                          </button>
                        </div>}
                      </div>
                    </section>

                  </div>
                </section>
              </div>

              {/* Right column */}
              <Checkout
                myCart={myCart}
                currentAddress={currentAddress}
                currentShipper={currentShipper}
                onOpenShipperModal={() => setIsOpenShipperModal(true)}
              />
            </div>
          </div>
          <AddressModal
            show={isOpenAddressModal}
            onClose={() => setIsOpenAddressModal(false)}
          />
          <AddCouponModal
            show={isOpenCouponModal}
            onClose={() => setIsOpenCouponModal(false)}
            myCart={myCart}
            myCarts={myCarts}
          />

          <AddDeliveryInstructionModal
            show={isOpenDeliveryModal}
            onClose={() => setIsOpenDeliveryModal(false)}
            currentAddress={currentAddress}
          />

          <SelectShipperModal
            show={isOpenShipperModal}
            onClose={() => setIsOpenShipperModal(false)}
            setCurrentShipper={setCurrentShipper}
            currentShipper={currentShipper}
            user={user}
            currentAddress={currentAddress}
          />
        </main>
      </Container>
    </div>
  );
}
